import { render } from "./CreateLinktoneInvite.vue?vue&type=template&id=792ee1c6&scoped=true"
import script from "./CreateLinktoneInvite.vue?vue&type=script&lang=js"
export * from "./CreateLinktoneInvite.vue?vue&type=script&lang=js"

import "./CreateLinktoneInvite.vue?vue&type=style&index=0&id=792ee1c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-792ee1c6"]])

export default __exports__